(function () {
  const el = document.getElementById("line-popup");
  if (!el) return;

  const delaySec = Number(el.getAttribute("data-delay-sec") || "10");
  const cooldownHours = Number(el.getAttribute("data-cooldown-hours") || "24");
  const lockMode = el.getAttribute("data-lock-mode") || "rolling_24h";
  const AUTO_MIN_MS = 3000; // 本人指示2026-09-12: 表示3秒で猫へ吸い込まれる

  const KEY = "lp_last_shown_key";
  const now = () => Date.now();
  const hours = (ms) => ms / 1000 / 60 / 60;

  function jstDateKey() {
    const d = new Date();
    const utc = d.getTime() + d.getTimezoneOffset() * 60000;
    const jst = new Date(utc + 9 * 60 * 60000);
    return `jst_${jst.getFullYear()}-${String(jst.getMonth() + 1).padStart(2, "0")}-${String(jst.getDate()).padStart(2, "0")}`;
  }
  function canShow() {
    const stored = localStorage.getItem(KEY);
    if (!stored) return true;
    if (lockMode === "calendar_day_jst") return stored !== jstDateKey();
    const last = Number(stored || 0);
    return !last || hours(now() - last) >= cooldownHours;
  }
  function markShown() {
    localStorage.setItem(KEY, lockMode === "calendar_day_jst" ? jstDateKey() : String(now()));
  }

  let minTimer = null, retreatT = null;
  function open() {
    clearTimeout(retreatT);
    el.classList.remove("is-retreat");
    try { document.documentElement.classList.remove("fx-cathide"); } catch (e) {} // 猫を出す(=ポップは猫から出る)
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    clearTimeout(minTimer);
    minTimer = setTimeout(minimize, AUTO_MIN_MS); // 放置で自動的に猫へ吸い込まれる
  }
  function minimize() {         // 猫のUIへ小さくなりながら吸い込まれる＋猫が受け取った合図でバウンド(本人指示2026-09-12)
    clearTimeout(minTimer);
    el.classList.add("is-retreat");
    el.setAttribute("aria-hidden", "true");
    var cat = document.getElementById("fxSup");
    if (cat) { setTimeout(function () { cat.classList.add("fx-sup-bounce"); setTimeout(function () { cat.classList.remove("fx-sup-bounce"); }, 520); }, 260); }
    clearTimeout(retreatT);
    retreatT = setTimeout(function () { el.classList.remove("is-open"); el.classList.remove("is-retreat"); }, 340);
  }

  // カード上で操作している間は自動引っ込みを止める
  el.addEventListener("mouseenter", () => clearTimeout(minTimer));
  el.addEventListener("mouseleave", () => {
    if (el.classList.contains("is-open")) { clearTimeout(minTimer); minTimer = setTimeout(minimize, AUTO_MIN_MS); }
  });

  // × / あとで → 猫に引っ込む
  el.querySelectorAll("[data-lp-min]").forEach((b) => b.addEventListener("click", minimize));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && el.classList.contains("is-open")) minimize();
  });

  // 本人指示2026-09-12: トップページで10秒経過したら表示(回遊条件は外す=本人が動きを確認できるように)。
  // トップ以外では自動表示しない(猫パネルにクーポン導線が常駐しているので戻れる)。
  // 本人指示2026-09-12: 動きを確認したいので、トップページでは10秒後に毎回表示→約2.5秒で猫へ戻る(クールダウン無し)。
  // ※本番で1日1回に戻す場合は if(isTop) を if(isTop && canShow()){ ... markShown(); ... } に戻すだけ。
  var isTop = (location.pathname === "/" || location.pathname === "");
  if (isTop) {
    window.setTimeout(function () { open(); }, Math.max(1, delaySec) * 1000);   // open()内で AUTO_MIN_MS(約2.5秒)後に猫へ戻る
  }

  const cta = document.getElementById("lp-line-cta");
  if (cta) cta.addEventListener("click", () => { /* GA4/Meta hook */ });
})();
